/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const STORE = 'STORE'
export const UPDATE = 'UPDATE'
export const CHECK = 'CHECK'
export const LOAD = 'LOAD'
export const UNLOAD = 'UNLOAD'

export default {
  STORE,
  UPDATE,
  CHECK,
  LOAD,
  UNLOAD
}
